<template>
  <div class="SerialView">
    <ATable
      ref="table"
      :data="items"
      hide-top-panel
      hide-button-insert
      hide-pagination
      border
      @cell-click="handleCellClick"
    >
      <el-table-column
        type="index"
        label="No"
        :index="handleIndex"            
        :width="$width.indexw"
      />
      <el-table-column
        prop="good_code"
        width="200"
        label="기계품번"
      />
      <el-table-column
        prop="good_name"
        width="200"
        label="기계명"
      />
      <el-table-column
        prop="code"        
        label="관리품번"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id !== editingId">
            {{scope.row.code}}
          </div>
          <div v-else>
            <el-input
              size="mini"
              v-model="scope.row.code"
              @keyup.native.enter="handleEnterCode(scope.row)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="product_name"
        width="200"
        label="관리품명"
      />
    </ATable>
  </div>
</template>
<script>
export default {
  name: "SerialView",
  data() {
    return {      
      items: [],
      editingId: -1,
      oldItem: null,
    }
  },
  props: {    
    /** contract_detail_id */
    id: {
      type: Number
    },
    title: {
      type: String,
      default: '품번조회',
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      if (!this.id) { return; }
      this.api.listSerialContractDetail(this.id).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
      });
    },
    calcelEditing() {
      if (this.editingId < 1) { return; }
      let index = this.items.findIndex(i => i.id === this.editingId);
      if (this.oldItem.id) {
        this.items.splice(index, 1, this.oldItem);
      } else {
        this.items.splice(index, 1);
      }
      this.editingId = -1;
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleCellClick(item, column) { 
      if (this.editingId === item.id) { return ; }
      this.calcelEditing();
      if (column.property !== "code") { return; }
      this.editingId = item.id;
      this.oldItem = this.util.clone(item);
    },
    handleEnterCode(item) {
      if (this.oldItem.code === item.code) {
        this.calcelEditing();
        return;
      }
      let data = { id: item.id, code: item.code };
      this.api.replaceSerial(data).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.editingId = -1;
      });
    },
  },
}
</script>